export abstract class Field {
  type:string='number'
  constructor(
    public name: string,
    public value: any,
    public onChange: (newValue: any,targetEl?:HTMLElement) => void,
  ) {
  }
  protected createContainer(): HTMLElement {
    const container = document.createElement('div');
    container.className = 'property-field '+this.type.toLocaleLowerCase();
    const label = document.createElement('label');
    label.htmlFor = this.name;
    label.textContent = this.name.charAt(0).toUpperCase() + this.name.slice(1) + ':';
    container.appendChild(label);

    return container;
  }

  abstract render(): HTMLElement;

  public destroy(): void {
    // Clean up

  }
}
